import Loadable from '../../components/loadable';

const GymDashboardSettings = Loadable({
  loader: () => import('../../pages/account_profile/gym_dashboard_settings'),
});

angular.module('gym').value('GymDashboardSettings', GymDashboardSettings);
